import ClickAwayWrapper from './ClickAwayWrapper';

export default ClickAwayWrapper;
